/**
 * Audio player for switch-compare-table
 * @requires ("component-base-compare-table.js")
 */
(function () {
  const audioList = document.querySelectorAll(".audio-player audio");
  for (const audio of audioList) {
    audio.onended = function () {
      $(".btn-graphic-ctn .soundwave-active").removeClass("playing");
    };
  }
  const audioPlayerList = document.querySelectorAll(
    ".switch-compare-table-wrapper .audio-player"
  );
  for (const audioPlayer of audioPlayerList) {
    audioPlayer.addEventListener("click", handleClickAudioPlayer);
  }
  function handleClickAudioPlayer(e) {
    /** @type {HTMLElement} */
    const el = e.currentTarget;
    var audioElement = el.querySelector(`audio`);
    var soundWave = el.querySelector(".soundwave-active");
    const soundwaveActive = el.querySelector(".soundwave-active");
    if (audioElement.paused) {
      const audioList = document.querySelectorAll(".audio-player audio");
      for (const audio of audioList) {
        audio.pause();
        audio.currentTime = 0;
      }
      $(".btn-graphic-ctn .soundwave-active").removeClass("playing");
      soundWave.classList.add("playing");
      audioElement.play();
    } else {
      audioElement.pause();
      soundwaveActive.classList.remove("playing");
      audioElement.currentTime = 0;
    }
  }
})();
